export const defaultHeaders = () => ({
  "Accept-language": "es",
  "X-Origin-Forced": window.location.origin,
});
